module.exports = __webpack_public_path__ + "img/icon-right.4605f278.svg";